/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { createBrowserRouter, RouterProvider } from 'react-router';

import { ExternalAppLayout } from 'shared-ui/external-app-base';
import { ErrorOrNotFoundPage } from 'shared-ui/components/ErrorPage/ErrorOrNotFoundPage';

import GatewayPage from './containers/GatewayPage';

const routeConfig = [
    {
        path: '/',
        element: <ExternalAppLayout className="ui-gateway" isGuestAllowed={true} />,
        errorElement: <ErrorOrNotFoundPage />,
        children: [
            {
                errorElement: <ErrorOrNotFoundPage />,
                children: [
                    {
                        // TODO: remove this path once the rest of UIs are update to the new path
                        path: '/camping/gateways/:recId',
                        element: <GatewayPage />,
                    },
                    {
                        path: '/gateways/:recId',
                        element: <GatewayPage />,
                    },
                ],
            },
        ],
    },
];

const browserRouter = createBrowserRouter(routeConfig);

export function Router() {
    return <RouterProvider router={browserRouter} />;
}
